// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"9f477f2c","528":"2bb3336f","837":"7f228849"}[chunkId] + ".chunk.css";
};